"use client";
import { usePathname } from "next/navigation";
import { useEffect, useState } from "react";
import AppointmentsIcon from "@/icons/Appointments.svg";
import BillingIcon from "@/icons/billing.svg";
import FormulasIcon from "@/icons/formulas.svg";
import PrescriptionIcon from "@/icons/prescription.svg";
import ReportsIcon from "@/icons/reports.svg";
import { getTranslation } from "@/i18n/get-translation";

interface IHowLucyHelpYouHero {
  locale: string;
}

export default function HowLucyHelpYouHero({ locale }: IHowLucyHelpYouHero) {
  const router = usePathname();
  const [currentPath, setCurrentPath] = useState<string>("");

  const t = getTranslation(locale, "howLucyhelpYou.hero");

  useEffect(() => {
    setCurrentPath(router);
  }, [router]);
  
  const howLucyTabs = [
    {
      href: `/${locale}/medical-appointment-software`,
      icon: (
        <AppointmentsIcon className="mr-1 max-w-[1.75rem] min-w-[1.75rem] w-full" />
      ),
      label: t("appointments"),
    },
    {
      href: `/${locale}/medical-billing-software`,
      icon: <BillingIcon className="mr-1 w-7" />,
      label: t("billing"),
    },
    {
      href: `/${locale}/medical-prescription-software`,
      icon: <PrescriptionIcon className="mr-1 w-7" />,
      label: t("prescription"),
    },
    {
      href: `/${locale}/medical-report-record-software`,
      icon: <ReportsIcon className="mr-1 w-7" />,
      label: t("reports"),
    },
    {
      href: `/${locale}/health-assistant-software`,
      icon: <FormulasIcon className="mr-1 w-7" />,
      label: t("formulas"),
    },
  ];

  return (
    <section className="bg-appointments-gradient xl:h-[34rem] lg:h-[28rem] h-[24rem] mt-24 lg:px-10 px-7 overflow-hidden flex items-center flex-col justify-center relative">
      <div className="flex flex-col items-center relative z-30">
        <h1 className="text-center leading-[1] text-primary-800 font-bold 2xl:text-[4.4vw] lg:text-[3.8vw] md:text-[2.8rem] text-[2.5rem]">
          {t("howLucyhelpYouTitle")}
        </h1>
        <p className="mt-6 xl:text-xl lg:text-lg max-w-xl text-center text-base font-light   text-primary-800">
          {t("howLucyhelpYouDesc")}
        </p>
      </div>
      <div
        className="scrollbar-list border-b border-b-primary-400 absolute md:bottom-7 bottom-0
          xl:w-[60rem] lg:w-[54rem] w-full mx-auto mt-0 lg:text-xl text-lg font-medium text-primary-800
          flex md:justify-center justify-start xl:gap-16 lg:gap-10 gap-8 md:overflow-hidden overflow-x-auto 
          md:px-0 px-5"
      >
        {howLucyTabs.map((item, index) => (
          <a
            key={index}
            href={item.href}
            className={`focus:outline-none md:pb-4 pb-3 ${
              currentPath === item.href
                ? "text-primary-700"
                : "text-primary-800"
            }`}
          >
            <div className="flex items-center font-medium">
              {item.icon}
              <span className="whitespace-nowrap">{item.label}</span>
            </div>
          </a>
        ))}
      </div>
    </section>
  );
}
